Wee.fn.make('categories', {
	init: function() {
		var scope = this,
			priv = scope.$private;

		$.screen.map([
			{
				max: 2,
				callback: function() {
					priv.bindEvents();
					priv.disableDropdown();
				}
			},
			{
				max: 2,
				init: false,
				callback: function() {
					$('ref:catDropdown').attr('aria-haspopup', true)
						.attr('aria-hidden', true)
						.next()
						.attr('aria-label', 'submenu');
				}
			},
			{
				min: 3,
				callback: function() {
					priv.enableDropdown();

					$('ref:catDropdown').removeAttr('aria-haspopup')
						.removeAttr('aria-hidden')
						.next()
						.removeAttr('aria-label');
				}
			},
			{
				min: 3,
				init: false,
				callback: function() {
					scope.unload();
				}
			}
		]);
	},
	unload: function() {
		$.events.off(false, '.categories');
	}
}, {
	/**
	 * Bind events
	 *
	 * @private
	 */
	bindEvents: function() {
		var scope = this;

		$('ref:catDropdown').on('click.categories', function() {
			$('ref:catFilter').isDisabled() ?
				scope.enableDropdown() :
				scope.disableDropdown();
		});
	},
	disableDropdown: function() {
		$('ref:catFilter').disable();
		$('ref:catDropdown').attr('aria-hidden', true);
	},
	enableDropdown: function() {
		$('ref:catFilter').enable();
		$('ref:catDropdown').attr('aria-hidden', false);
	}
});